
export default {
  name: 'AppToggle',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconSize() {
      return this.value ? 17 : 16;
    }
  }
};
